import { creationIntent } from "./onboardingIntent";

/** Why someone reached the login screen, when we know: saving work they made
 * in a free tool, or starting from content they handed over (a link, text,
 * a PDF or a template). Everyone else sees the plain welcome. */
export type LoginReason = "saveWork" | "startEngine";

export function loginReason(search: URLSearchParams, returnTo: string): LoginReason | null {
  if (search.get("claimPost") && search.get("claimToken")) return "saveWork";
  if (creationIntent(search.toString())) return "startEngine";
  const returnSearch = new URL(returnTo, "https://app.invalid").search;
  return creationIntent(returnSearch) ? "startEngine" : null;
}

export const LOGIN_REASON_COPY: Record<LoginReason, { title: string; description: string }> = {
  startEngine: {
    title: "Start your social media engine",
    description: "Create your free account to let WaveGen handle your social media marketing.",
  },
  saveWork: {
    title: "Save your work in progress",
    description: "Create your free account to continue your creation.",
  },
};
